import React from 'react';

import NoDataWidget from '../NoDataWidget';
import {getQuestionDisplayLabel} from '../../screens/FormBuilderScreen/shared';

function NoAnswersYet({id, question, options, unPin}) {
  return <NoDataWidget id={id} title={getQuestionDisplayLabel(question)} options={options} question={question} unPin={unPin}/>;
}

export default NoAnswersYet;
